import { Component } from '@angular/core';
import { AppService } from '@ui-components/services';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  selected = 0;
  tabs = ['basic', 'personal', 'experience', 'professional', 'data']
  person_id: number | undefined;

  constructor(
    protected _app_service: AppService,
    protected _router: Router,
    protected _route: ActivatedRoute
  ) {}

  ngOnInit() {
    this._route.params.subscribe(
      (params: Params) => {
        this.selected = this.tabs.findIndex((element: string) => {
          return element === params['type']
        });
        
        this.selected = this.selected === -1 ? 0 : this.selected;
        this.go(this.selected);
      }
    );
  }

  go(index: number ) {
    const url = this.tabs[index];
    const person_id_param = this._route.snapshot.paramMap.get('person_id');
    this._router.navigate(person_id_param ? ['/profile', url, person_id_param] : ['/profile', url]);   
  }

}
